// ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ allowedRoles, children }) {
  const token = localStorage.getItem("token");

  // ❌ Make sure you parse role from token or user info
  const user = token ? JSON.parse(atob(token.split(".")[1])) : null;

  if (!token || !user || !allowedRoles.includes(user.role)) {
    // redirect if not allowed
    return <Navigate to="/" replace />;
  }

  // ✅ Render children as JSX
  return <>{children}</>;
}
